import type { MetricFormat } from './contracts';

const nf0 = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 1 });

export function formatNumber(n: number): string {
  return nf0.format(n);
}

export function formatDecimal(n: number): string {
  return nf1.format(n);
}

/** Compact currency for headline figures, e.g. "kr 2,8 mio." or "kr 312k". */
export function formatCompactCurrency(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `kr ${nf1.format(n / 1_000_000)} mio.`;
  if (Math.abs(n) >= 1_000) return `kr ${nf0.format(Math.round(n / 1000))}k`;
  return `kr ${nf0.format(n)}`;
}

/** Formats a ratio (0.042) as a signed percentage ("+4,2 %"). */
export function formatPercentRatio(r: number): string {
  const sign = r > 0 ? '+' : '';
  return `${sign}${nf1.format(r * 100)} %`;
}

/** Formats a metric value according to its declared format. */
export function formatMetric(value: number, format: MetricFormat, unit?: string): string {
  switch (format) {
    case 'currency':
      return formatCompactCurrency(value);
    case 'percent':
      return `${nf1.format(value)} %`;
    case 'duration':
      return `${nf1.format(value)} t`;
    case 'number':
    default:
      return unit ? `${nf0.format(value)} ${unit}` : nf0.format(value);
  }
}

const nfFull = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 });

/** Formats a table cell per its column format ('—' for null/empty). */
export function formatTableCell(value: string | number | null, format?: 'text' | 'currency' | 'number' | 'percent' | 'date'): string {
  if (value === null || value === '') return '—';
  if (typeof value === 'number') {
    if (format === 'currency') return `kr ${nfFull.format(Math.round(value))}`;
    if (format === 'percent') return `${nfFull.format(value)} %`;
    return nfFull.format(value);
  }
  return value;
}
